interface Options {
  headers?: object | null;
  params?: object | null;
  query?: object | null;
  body?: object | null;
  auth?: boolean | null;
  client?: boolean | null;
}

interface Response {
  data: any;
  error: any;
}

export const useAPIHandler = async (method: string, url: string, data: Options): Promise<Response> => {
  const { access_token } = useAuth();
  const runtimeConfig = useRuntimeConfig();
  const options: any = { method, ...useOmit(data, 'auth') };

  options.headers = {
    ...(options.headers || {}),
  };

  if (data?.auth) {
    options.headers = { authorization: `Bearer ${access_token}` };
  }
  options.headers.partner_id = runtimeConfig.public.partnerCode;

  try {
    const apiResult: any = await $apiServer(url, options);

    const response: Response = {
      data: apiResult?.data ?? null,
      error: apiResult?.error ?? null,
    };

    return response;
  } catch (error: any) {
    const message =
      error?.response?._data?.message ||  
      error?.data?.message ||
      error?.message ||
      "Something went wrong";

    return {
      data: null,
      error: { message },
    };
  }
};
